export default __webpack_public_path__ + "static/media/img-41.1204c737.jpg";